import { useParams } from 'next/navigation';

export const useResolvedLocalizedObject = (localized: object | string) => {

  const { locale: nextLocale } = useParams();

  const { locale } = getLocalizationInfo(nextLocale);

  return localized[locale as keyof typeof localized] ?? localized ?? '';
};

import { Currency } from '@commercetools/frontend-sdk/lib/types/Currency';

interface LocalizationMapping {
  locale: string;
  currency: Currency;
  currencyCode: string;
  countryName: string;
  countryCode: string;
}

const localizationMapper = {
  au: {
    locale: 'en_AU',
    currency: 'AUD',
    currencyCode: '$A',
    countryCode: 'AU',
    countryName: 'Australia',
  },
  nz: {
    locale: 'en_NZ',
    currency: 'NZD',
    currencyCode: '$',
    countryCode: 'NZ',
    countryName: 'New Zealand',
  },
} as Record<string, LocalizationMapping>;

const locales = Object.keys(localizationMapper);
const defaultLocale = locales[0];

export const i18nConfig = { locales, defaultLocale };

const getLocalizationInfo = (locale: string) => {
  if (!(locale in localizationMapper)) {
    console.warn(
      `Invalid locale ${locale} provided. Possible values are ${Object.keys(localizationMapper).join(', ')}`,
    );

    return localizationMapper[defaultLocale];
  }

  return localizationMapper[locale as keyof typeof localizationMapper];
};
